import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dateGrid" }
const _hoisted_2 = { style: {"grid-row":"1","grid-column":"2"} }
const _hoisted_3 = { style: {"grid-row":"1","grid-column":"4"} }
const _hoisted_4 = { style: {"grid-row":"1","grid-column":"6"} }
const _hoisted_5 = { style: {"grid-row":"1","grid-column":"8"} }
const _hoisted_6 = { style: {"grid-row":"1","grid-column":"10"} }
const _hoisted_7 = { style: {"grid-row":"2","grid-column":"2"} }
const _hoisted_8 = { style: {"grid-row":"2","grid-column":"3"} }
const _hoisted_9 = { style: {"grid-row":"2","grid-column":"4"} }
const _hoisted_10 = { style: {"grid-row":"2","grid-column":"5"} }
const _hoisted_11 = { style: {"grid-row":"2","grid-column":"6"} }
const _hoisted_12 = {
  key: 3,
  style: {"grid-row":"2","grid-column":"7"}
}
const _hoisted_13 = { style: {"grid-row":"2","grid-column":"8"} }
const _hoisted_14 = { style: {"grid-row":"2","grid-column":"9"} }
const _hoisted_15 = { style: {"grid-row":"2","grid-column":"10"} }

import { ref, onMounted, nextTick } from 'vue'
import gen from "@/functions/general.js"


export default /*@__PURE__*/_defineComponent({
  __name: 'inputNewDate',
  props: {
  dateIso: {
    type: String,
    required: true,
  },
  isNew: {
    //Boolean for signalling that props.dateIso is a new date (and component therefore emits 'changed' upon being mounted)
    type: Boolean,
    default: false,
  },
  trash: {
    type: Boolean,
    default: false
  },
  calendar: {
    type: Boolean,
    default: true
  },
  show: {
    type: String,
    default: 'date'
  },
  showHeader: {
    type: Boolean,
    default: true
  },
},
  emits: ['changed', 'delete'],
  setup(__props, { expose: __expose, emit: __emit }) {

const dayRef = ref(null)
const monthRef = ref(null)
const yearRef = ref(null)
const hourRef = ref(null)
const minuteRef = ref(null)

__expose({
  dayRef,
  monthRef,
  yearRef,
  hourRef,
  minuteRef, 
  initialize,
})

const props = __props

const emits = __emit

const day = ref("")
const month = ref("")
const year = ref("")
const hour = ref("")
const minute = ref("")

const lastYear = ref(null)
const lastMonth = ref(null)
const lastDay = ref(null)
const lastHour = ref(null)
const lastMinute = ref(null)
const lastIso = ref(null)

function initialize() {
  const initialDate = new Date(props.dateIso)
  if (!initialDate) {return}

  dateToVariables(initialDate)

  if (props.isNew) {
    emits ('changed', lastIso.value)
  }
}


function fillDefault() {
  if (lastIso.value) return;
  const initialDate = new Date()
  dateToVariables(initialDate)
  emits ('changed', lastIso.value)
}

function dateToVariables(initialDate) {
  //Decompose date
  lastYear.value = initialDate.getFullYear()
  year.value = lastYear.value ? lastYear.value.toString() : ""
  lastMonth.value = initialDate.getMonth() + 1
  month.value = lastMonth.value ? lastMonth.value.toString() : ""
  lastDay.value = initialDate.getDate()
  day.value = lastDay.value ? lastDay.value.toString() : ""
  //Decompose time
  const hours = "0" + initialDate.getHours().toString()
  lastHour.value = hours.slice(-2)
  hour.value = lastHour.value ? lastHour.value.toString() : "00"
  const minutes = "0" + initialDate.getMinutes().toString()
  lastMinute.value = minutes.slice(-2)
  minute.value = lastMinute.value ? lastMinute.value.toString() : "00"
  //LastIso
  const currIso = createIsoString()
  lastIso.value = currIso
}



function handleYear(e) {
  gen.onlyInteger(e)
  jumpOnArrow(e)
  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
    e.preventDefault()
    const yearInt = parseInt(year.value, 10)
    if (e.key === "ArrowUp" && yearInt < 2300) {
      year.value = (yearInt + 1).toString()
    } else if (e.key === "ArrowDown" && yearInt > 1900) {
      year.value = (yearInt - 1).toString()
    }    
    selectRef(yearRef.value)
  }
}

function handleMonth(e) {
  gen.onlyInteger(e)
  jumpOnArrow(e)
  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
    e.preventDefault()
    const monthInt = parseInt(month.value, 10)
    if (e.key === "ArrowUp" && monthInt < 12) {
      month.value = (monthInt + 1).toString()
    } else if (e.key === "ArrowDown" && monthInt > 1) {
      month.value = (monthInt - 1).toString()
    }
    selectRef(monthRef.value)
  }
}

function handleDay(e) {
  gen.onlyInteger(e)
  jumpOnArrow(e)
  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
    e.preventDefault()
    const dayInt = parseInt(day.value, 10)
    if (e.key === "ArrowUp" && dayInt < 31) {
      day.value = (dayInt + 1).toString()
    } else if (e.key === "ArrowDown" && dayInt > 1) {
      day.value = (dayInt - 1).toString()
    }
    selectRef(dayRef.value)
  }
}

function handleHour(e) {
  gen.onlyInteger(e)
  jumpOnArrow(e)
  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
    e.preventDefault()
    const hourInt = parseInt(hour.value, 10)
    if (e.key === "ArrowUp" && hourInt < 23) {
      hour.value = (hourInt + 1).toString()
    } else if (e.key === "ArrowDown" && hourInt > 0) {
      hour.value = (hourInt - 1).toString()
    }
    selectRef(hourRef.value)
  }
}

function handleMinute(e) {
  gen.onlyInteger(e)
  jumpOnArrow(e)
  if (e.key === "ArrowUp" || e.key === "ArrowDown") {
    e.preventDefault()
    const minuteInt = parseInt(minute.value, 10)
    if (e.key === "ArrowUp" && minuteInt < 59) {
      minute.value = (minuteInt + 1).toString()
    } else if (e.key === "ArrowDown" && minuteInt > 0) {
      minute.value = (minuteInt - 1).toString()
    }
    selectRef(minuteRef.value)
  }
}

function validateYear() {
  if (year.value.length === 2) {
    year.value = "20" + year.value
  }
  const yearInt = parseInt(year.value, 10)
  if (yearInt < 1900 || yearInt > 2300) {
    year.value = lastYear.value || "";
    return;
  }
  handleEmit()
}

function validateMonth() {
  if (parseInt(month.value, 10) > 12) {
    month.value = lastMonth.value || "";
    return;
  }
  handleEmit()
}

function validateDay() {
  if (parseInt(day.value, 10) > 31) {
    day.value = lastDay.value || "";
    return;
  }
  handleEmit()
}

function validateHour() {
  if (parseInt(hour.value, 10) > 23) {
    hour.value = lastHour.value || "";
    return;
  }
  handleEmit()
}

function validateMinute() {
  if (minute.value.length === 1) {
    minute.value = "0" + minute.value
  }
  if (parseInt(minute.value, 10) > 59) {
    minute.value = lastMinute.value || "";
    return;
  }
  handleEmit()
}

function getDateString() {
  const dayInt = parseInt(day.value, 10)
  const monthInt = parseInt(month.value, 10)
  const yearInt = parseInt(year.value, 10)
  if (!day.value || !month.value || !year.value || dayInt > 31 || monthInt > 12 || yearInt < 1900 || yearInt > 2300) {return null}
  var date = new Date(year.value, month.value -1, day.value)
  if (!date) {return null}

  let dayString = "0" + date.getDate().toString()
  dayString = dayString.slice(-2)
  const monthIntFromDate = date.getMonth() + 1
  let monthString = "0" + monthIntFromDate.toString()
  monthString  = monthString.slice(-2)
  const yearString = date.getFullYear().toString()

  return `${yearString}-${monthString}-${dayString}`
}

function getTimeString() {
  const hourInt = parseInt(hour.value, 10)
  const minuteInt = parseInt(minute.value, 10)
  if (hour.value === "" || minute.value === "" || hourInt > 23 || minuteInt > 59) {return null}
  var time = new Date(1970, 0, 1, hour.value, minute.value)
  if (!time) {return null}

  let hours = "0" + time.getHours().toString()
  hours = hours.slice(-2)
  let minutes = "0" + time.getMinutes().toString()
  minutes = minutes.slice(-2)
  let seconds = "00.000"

  return `${hours}:${minutes}:${seconds}`
}

function createIsoString() {
  let ret = ""
  if (['dateTime', 'date'].includes(props.show)) {
    const dateString = getDateString()
    if (!dateString) return;
    ret = dateString
  }
  if (['dateTime'].includes(props.show)) {
    ret += "T"
  }
  if (['dateTime', 'time'].includes(props.show)) {
    const timeString = getTimeString()
    if (!timeString) return;
    ret += timeString
  }
  return ret;
}

function handleEmit() {
  const newIso = createIsoString()
  if (lastIso.value !== newIso) {
    lastIso.value = newIso
    emits ('changed', newIso)
  }
}

function deleteDate() {
  day.value = ""
  month.value = ""
  year.value = ""
  hour.value = ""
  minute.value = ""
  lastIso.value = null
  emits ('delete')
}

function selectRef(newRef) {
  nextTick(() => {
    newRef.$el.focus()
    newRef.$el.select()
  })
}

function jumpRight(e) {
  const nextMap = {
    'day': monthRef.value,
    'month': yearRef.value,
    'year': hourRef.value,
    'hour': minuteRef.value,
  }
  const newRef = nextMap[e.target.id]
  if (!newRef) return
  e.preventDefault()
  newRef.$el.focus()
  newRef.$el.select()
  // newRef.$el.setSelectionRange(0, 0)
}

function jumpLeft(e) {
  const nextMap = {
    'minute': hourRef.value,
    'hour': yearRef.value,
    'year': monthRef.value,
    'month': dayRef.value,
  }
  const newRef = nextMap[e.target.id]
  if (!newRef) return
  e.preventDefault()
  newRef.$el.focus()
  newRef.$el.select()
  // newRef.$el.setSelectionRange(newRef.$el.value.length, newRef.$el.value.length)
}

function jump(e) {
  const target = e.target
  const key = e.key
  if (gen.isControlKey(key) && !['Backspace'].includes(key)) return;
  // Jump
  const textLength = target.value.length
  const maxLength = parseInt(target.maxLength, 10)
  if (textLength >= maxLength) {
    jumpRight(e)
  } else if (key === 'Backspace' && textLength === 0) {
    jumpLeft(e)
  }
}


function jumpOnArrow(e) {
  const target = e.target
  const key = e.key
  if (!['ArrowLeft', 'ArrowRight'].includes(key)) return;
  // Jump
  const selectionStart = target.selectionStart
  const selectionEnd = target.selectionEnd
  const textLength = target.value.length
  if (key === "ArrowRight" && [selectionStart, selectionEnd].includes(textLength)) {
    jumpRight(e)
  } else if (key === "ArrowLeft" && selectionStart === 0) {
    jumpLeft(e)
  }
}


onMounted(() => {
  initialize()
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (['dateTime', 'date'].includes(__props.show) && props.showHeader)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_text_item, {
              txt: "Jour",
              styles: "main-l font-s align-c"
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_text_item, {
              txt: "Mois",
              styles: "main-l font-s align-c"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_text_item, {
              txt: "Année",
              styles: "main-l font-s align-c"
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (['dateTime', 'time'].includes(__props.show) && props.showHeader)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_text_item, {
              txt: "Heure",
              styles: "main-l font-s align-c"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_text_item, {
              txt: "Min",
              styles: "main-l font-s align-c"
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (['dateTime', 'date'].includes(__props.show))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_inputBox, { style: {"width":"3rem"} }, {
              default: _withCtx(() => [
                _createVNode(_component_inputLineNew2, {
                  maxlength: "2",
                  ref_key: "dayRef",
                  ref: dayRef,
                  id: "day",
                  modelValue: day.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((day).value = $event)),
                  onKeydown: handleDay,
                  onKeyup: jump,
                  onBlur: _cache[1] || (_cache[1] = ($event: any) => (validateDay())),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (fillDefault()))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_text_item, {
              txt: "/",
              styles: "main-m",
              class: "pad-m"
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_inputBox, { style: {"width":"3rem"} }, {
              default: _withCtx(() => [
                _createVNode(_component_inputLineNew2, {
                  maxlength: "2",
                  ref_key: "monthRef",
                  ref: monthRef,
                  id: "month",
                  modelValue: month.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((month).value = $event)),
                  onKeydown: handleMonth,
                  onKeyup: jump,
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (validateMonth())),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (fillDefault()))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_text_item, {
              txt: "/",
              styles: "main-m",
              class: "pad-m"
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_inputBox, { style: {"width":"4rem"} }, {
              default: _withCtx(() => [
                _createVNode(_component_inputLineNew2, {
                  maxlength: "4",
                  ref_key: "yearRef",
                  ref: yearRef,
                  id: "year",
                  modelValue: year.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((year).value = $event)),
                  onKeydown: handleYear,
                  onKeyup: jump,
                  onBlur: _cache[7] || (_cache[7] = ($event: any) => (validateYear())),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (fillDefault()))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (['dateTime'].includes(__props.show))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_text_item, {
            txt: "à",
            styles: "main-m",
            class: "pad-m mleft-10",
            style: {"margin-right":"1rem"}
          })
        ]))
      : _createCommentVNode("", true),
    (['dateTime', 'time'].includes(__props.show))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_inputBox, { style: {"width":"3rem"} }, {
              default: _withCtx(() => [
                _createVNode(_component_inputLineNew2, {
                  maxlength: "2",
                  ref_key: "hourRef",
                  ref: hourRef,
                  id: "hour",
                  modelValue: hour.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((hour).value = $event)),
                  onKeydown: handleHour,
                  onKeyup: jump,
                  onBlur: _cache[10] || (_cache[10] = ($event: any) => (validateHour())),
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (fillDefault()))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_text_item, {
              txt: ":",
              styles: "main-m",
              class: "pad-m"
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_inputBox, { style: {"width":"3rem"} }, {
              default: _withCtx(() => [
                _createVNode(_component_inputLineNew2, {
                  maxlength: "2",
                  ref_key: "minuteRef",
                  ref: minuteRef,
                  id: "minute",
                  modelValue: minute.value,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((minute).value = $event)),
                  onKeydown: handleMinute,
                  onKeyup: jump,
                  onBlur: _cache[13] || (_cache[13] = ($event: any) => (validateMinute())),
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (fillDefault()))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (__props.trash === true)
      ? (_openBlock(), _createBlock(_component_buttonGroup, {
          key: 5,
          class: "mleft-08",
          style: {"grid-row":"2","grid-column":"11"},
          onClick: deleteDate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_item, {
              icon: "trash",
              styles: "main-l size-m",
              style: {"margin-top":"0.15rem"}
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})